import AddContractorsAndVendors from "../../Operations/AddContractorsAndVendors";
import { ContractorsListComp } from "../../Operations/Contractors/Contractors/Contractors";
import AddWorkOrders from "../../Operations/Contractors/WorkOrders/AddWorkOrders";
import WorkOrderDetailsPage from "../../Operations/Contractors/WorkOrders/WorkOrderDetailsPage";
import ContractorBillForm from "../../Operations/Contractors/WorkOrders/ContractorBillForm";
import { WorkOrdersListComp } from "../../Operations/Contractors/WorkOrders/WorkOrders";
import StoreDashboard from "../../Operations/Dashboard/StoreDashboard";
import AddPurchaseOrders from "../../Operations/Vendor/PurchaseOrders/AddPurchaseOrder";
import PurchaseOrderDetailsPage from "../../Operations/Vendor/PurchaseOrders/PurchaseOrderDetailsPage";
import { PurchaseOrdersListComp } from "../../Operations/Vendor/PurchaseOrders/PurchaseOrders";
import GrnTable from "../../Operations/Vendor/GRN/GrnTable";
import AddGrn from "../../Operations/Vendor/GRN/AddGrn";
import { VendorsListComp } from "../../Operations/Vendor/Vendors/Vendors";
import { StocksTable } from "../../Operations/Stocks/StocksTable";
import AddStock from "../../Operations/Stocks/AddStock";
import { StockAdjustmentTable } from "../../Operations/Stocks/StockAdjustmentTable";
import AddStockAdjustment from "../../Operations/Stocks/AddStockAdjustment";
import StockDetailsPage from "../../Operations/Stocks/StockDetailsPage";
import { CategoryTable } from "../../Operations/Stocks/Configuration/CategoryTable";
import AddCategory from "../../Operations/Stocks/Configuration/AddCategory";
import { UOMTable } from "../../Operations/Stocks/Configuration/UOMTable";
import AddUOM from "../../Operations/Stocks/Configuration/AddUOM";
import { GatePassTable } from "../../Operations/GatePass/GatePassTable";
import AddGatePass from "../../Operations/GatePass/AddGatePass";
import { DemandNoteTable } from "../../Operations/Stocks/DemandNote/DemandNoteTable";
import AddDemandNote from "../../Operations/Stocks/DemandNote/AddDemandNote";
import MaterialRequisitions from "../../Operations/Stocks/MaterialRequisitions/MaterialRequisitions";
import StockReport from "../../Operations/Stocks/StockReport/StockReport";
import GatepassDetailsPage from "../../Operations/GatePass/GatepassDetailsPage";
import SiteInventoryValuationReport from "../../Operations/Store/Reports/SiteInventoryValuationReport";
import BOQConsumptionReconciliationReport from "../../Operations/Store/Reports/BOQConsumptionReconciliationReport";
import GoodsReceiptRegisterReport from "../../Operations/Store/Reports/GoodsReceiptRegisterReport";
import MaterialIssueRegisterReport from "../../Operations/Store/Reports/MaterialIssueRegisterReport";
import InterSiteTransferReport from "../../Operations/Store/Reports/InterSiteTransferReport";
import CriticalStockReorderReport from "../../Operations/Store/Reports/CriticalStockReorderReport";

export const storeRoutes = [
  {
    path: "/store/dashboard",
    component: <StoreDashboard />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/contractors/contractors",
    component: <ContractorsListComp />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/contractors/contractors/add",
    component: <AddContractorsAndVendors />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/contractors/work-order",
    component: <WorkOrdersListComp />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/contractors/work-order/add",
    component: <AddWorkOrders />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/contractors/work-order/details/:id",
    component: <WorkOrderDetailsPage />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/contractors/work-order/bills/add/:workOrderId?",
    component: <ContractorBillForm />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/contractors/work-order/bills/add",
    component: <ContractorBillForm />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/vendors/vendors",
    component: <VendorsListComp />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/vendors/add",
    component: <AddContractorsAndVendors isContractor={false} />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/vendors/purchase-order",
    component: <PurchaseOrdersListComp />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/vendors/GRN",
    component: <GrnTable />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/GRN/add",
    component: <AddGrn />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/purchase-order/details/:id",
    component: <PurchaseOrderDetailsPage />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/purchase-order/add",
    component: <AddPurchaseOrders />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/material",
    component: <StocksTable />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/material/add",
    component: <AddStock />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/stock",
    component: <StockAdjustmentTable />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/stock/add",
    component: <AddStockAdjustment />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/stock/details/:materialId",
    component: <StockDetailsPage />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/material-requisition",
    component: <DemandNoteTable />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/material-requisition/add",
    component: <AddDemandNote />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/material-requisition/edit/:id",
    component: <AddDemandNote />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/demand-note",
    component: <DemandNoteTable />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/demand-note/add",
    component: <AddDemandNote />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/demand-note/edit/:id",
    component: <AddDemandNote />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/material/demand-note",
    component: <DemandNoteTable />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/material/demand-note/add",
    component: <AddDemandNote />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/material/demand-note/edit/:id",
    component: <AddDemandNote />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/purchase-requisitions",
    component: <MaterialRequisitions />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/report/stock-report",
    component: <StockReport />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/configuration/category",
    component: <CategoryTable />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/configuration/category/add",
    component: <AddCategory />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/configuration/uom",
    component: <UOMTable />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/configuration/uom/add",
    component: <AddUOM />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/gate-pass",
    component: <GatePassTable />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/gate-pass/add",
    component: <AddGatePass />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/gate-pass/details/:id",
    component: <GatepassDetailsPage />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/reports",
    component: <SiteInventoryValuationReport />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/reports/stock-valuation",
    component: <SiteInventoryValuationReport />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/reports/boq-consumption",
    component: <BOQConsumptionReconciliationReport />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/reports/grn-register",
    component: <GoodsReceiptRegisterReport />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/reports/min-register",
    component: <MaterialIssueRegisterReport />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/reports/inter-site-transfers",
    component: <InterSiteTransferReport />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/store/reports/reorder-alerts",
    component: <CriticalStockReorderReport />,
    rolename: "Store Dashboard_View",
  },
];
